import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ customerReference4: string }>;

export const DispatchcustomerReference4: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/CustomerReference4",
        customerReference4: props.parameter.customerReference4,
    });
};

export const chain = [DispatchcustomerReference4];

const setcustomerReference4 = createHandlerChainRunner(chain, "customerReference4");
export default setcustomerReference4;
